import { AddSquareSmallIcon } from "assets/icons";
import { ExpertiseSectionProps } from "interfaces/ExternalPage/SpeakerLandingPage.interface";
import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import ChevronUp from "assets/icons/ChevronUp";

export default function ExpertiseSection({ expertise }: ExpertiseSectionProps) {
  const [isExpanded, setIsExpanded] = useState(false);

  function handleSeeAllExpertise() {
    setIsExpanded(!isExpanded);
  }

  const displayedExpertise = isExpanded ? expertise : expertise.slice(0, 5);

  return (
    <section className="mx-auto">
      <motion.h2 className="text-lg sm:text-xl font-monaMedium text-[#333333] mb-2">
        Expertise
      </motion.h2>
      <div className="flex flex-wrap gap-2 sm:gap-[15px]">
        <AnimatePresence mode="popLayout">
          {displayedExpertise.map((item, index) => (
            <motion.span
              key={item}
              initial={{ opacity: 0, scale: 0.8, y: -10 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.8, y: -10 }}
              transition={{
                duration: 0.4,
                delay: index * 0.05,
                ease: [0.4, 0.0, 0.2, 1],
              }}
              layout
              className="px-[6px] h-[32px] flex items-center bg-[#FCEDDE] text-[#B93815] rounded-[50px] font-monaMedium border border-[#F9DBAF] active:scale-95 cursor-pointer text-sm sm:text-base"
            >
              {item}
            </motion.span>
          ))}
        </AnimatePresence>

        {expertise.length > 5 && (
          <motion.button
            layout
            transition={{ duration: 0.4, ease: [0.4, 0.0, 0.2, 1] }}
            className="flex items-center text-[#344054] font-monaMedium bg-white border border-[#D0D5DD] rounded-md px-2 py-[6px] gap-1 hover:bg-[#f5f5f5] hover:border-[#f5f5f5] transition-colors duration-200"
            onClick={handleSeeAllExpertise}
          >
            {isExpanded ? "See less" : "See all"}{" "}
            <AnimatePresence mode="wait">
              {isExpanded ? (
                <motion.span
                  key="icon"
                  initial={{ opacity: 0, scale: 0.5 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.5 }}
                  transition={{ duration: 0.2 }}
                  className="flex items-center"
                >
                  <ChevronUp stroke="currentColor" />
                </motion.span>
              ) : (
                <motion.span
                  key="icon"
                  initial={{ opacity: 0, scale: 0.5 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.5 }}
                  transition={{ duration: 0.2 }}
                  className="flex items-center"
                >
                  <AddSquareSmallIcon stroke="currentColor" />
                </motion.span>
              )}
            </AnimatePresence>
          </motion.button>
        )}
      </div>
    </section>
  );
}
